<h2 mat-dialog-title>{{ isEditMode ? 'Modify User' : 'Add User' }}</h2>
@if (!isLoading) {
    <form [formGroup]="addUserForm" novalidate>
        <mat-dialog-content class="mat-typography">
            <div class="form-grid">

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Full Name</mat-label>
                    <input matInput name="name" formControlName="name" required autocomplete="name">
                    <mat-error>Name is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" name="email" formControlName="email" required email autocomplete="email">
                    <mat-error>Enter a valid email.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" name="password" formControlName="password" [required]="!isEditMode" minlength="3" autocomplete="new-password">
                    <mat-hint>At least 3 characters.</mat-hint>
                    <mat-error>Password is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Country</mat-label>
                    <input matInput name="country" formControlName="country" required maxlength="80" autocomplete="country-name">
                    <mat-error>Country is required.</mat-error>
                </mat-form-field>

                @if (isEditMode) {
                    <mat-form-field appearance="fill">
                        <mat-label>Allow password change</mat-label>
                        <mat-select formControlName="updatePassAllowed">
                            <mat-option [value]="null">No change</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Mandatory password change</mat-label>
                        <mat-select formControlName="updatePassMandatory">
                            <mat-option [value]="null">No change</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                } @else {
                    <mat-slide-toggle class="full" name="updatePassAllowed" formControlName="updatePassAllowed">Allow password change</mat-slide-toggle>
                }
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="addUserForm.invalid" (click)="isEditMode ? onUpdateUser() : onAddUser()">Save</button>
        </mat-dialog-actions>
    </form>
}@else{
    <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="custom-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
}
